import { api } from 'data/api/api'

import { CreatePhotoResp, GetPhotosArgs, GetPhotosResp } from '../types/media-upload'

export const getPhotos = ({ type, photoEntryId, tempUuid }: GetPhotosArgs) =>
  api.get<GetPhotosResp>('/photos', {
    params: { type, photo_entry_id: photoEntryId, temp_uuid: tempUuid },
  })

export const createPhoto = (photo: FormData) => api.post<CreatePhotoResp>('/photos', photo)
